import {
  Input,
  Directive,
  HostBinding,
} from '@angular/core';
import { BootstrapColor } from '../../global-types';

@Directive({
  selector: '[bpBadge]',
  exportAs: 'bpBadge',
})
export class BpBadgeDirective {
  @Input() color: BootstrapColor = 'primary';
  @Input() pill = false;

  @HostBinding('class') public get _class() {
    let cls = 'badge';
    if (this.color) {
      cls += ` badge-${this.color}`;
    }
    if (this.pill) {
      cls += ' badge-pill';
    }

    return cls;
  }
}
